// extracted by mini-css-extract-plugin
module.exports = {"card":"Home_card__2-MXE","box":"Home_box__6f9fh"};